import {Component, OnInit} from '@angular/core';
import {IQApiService} from '../../provider/iqapi/iqapi.service';
import {Router} from '@angular/router';
import {APP_ROUTES, IQAPI_ROUTES} from '../../../environments/environment';
import {StorageService} from '../../provider/storage/storage.service';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {tap} from 'rxjs/operators';
import {ErrorHandlingService} from '../../provider/error-handling/error-handling.service';
import {ConfigurationObject} from '../../interfaces/interfaces.regisafe';
import {AppConfig} from '../../app.config';
import {UserService} from '../../provider/user/user.service';
import {Location} from '@angular/common';

@Component({
	selector: 'app-abmeldung',
	templateUrl: './abmeldung.page.html',
	styleUrls: ['./abmeldung.page.scss'],
})
export class AbmeldungPage implements OnInit {

	public configuration: ConfigurationObject;

	constructor(private iqAPI: IQApiService,
				private router: Router,
				private storageService: StorageService,
				private httpClient: HttpClient,
				private errorHandling: ErrorHandlingService,
				private userService: UserService,
				public appConfig: AppConfig,
				private location: Location) {

		this.configuration = this.appConfig.getConfig();
	}

	ngOnInit() {
	}

	async ionViewDidEnter() {
		const check = await this.userService.checkFilesInProcess();
		if (check) {
			if (check.role === 'objects-in-process') {
				return false;
			}
		}
		setTimeout(() => {
			this.sessionLogout();
		}, 500);
	}

	sessionLogout() {
		const accountData = {
			apiID: this.configuration.iqapiAppId,
			sessionToken : this.storageService.getToken() || '123'
		};
		const options: object = {headers: {}, responseType: 'json', reportProgress: true, observe: 'response'};
		this.httpClient
			.post(this.configuration.iqapiEndpoint + IQAPI_ROUTES.logout, accountData, options)
			.pipe(tap((res: HttpResponse<any>) => {
				// SessionToken aus Datenbank löschen
				this.storageService.removeToken();
			}))
			.subscribe((data: HttpResponse<any>) => {
				// Weiterleitung zur Anmeldung
				this.router.navigateByUrl(APP_ROUTES.anmeldung);
			}, (error) => {
				// Fehlerfall ignorieren, ggf. vorhandenen Token löschen und Weiterleitung zur Anmeldung
				this.storageService.removeToken();
				this.router.navigate([APP_ROUTES.anmeldung]);
			});
	}

}
